/**
 * created by wang lei
 xxxxx页面
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BaseTable from "../../../../components/baseTable/BaseTable";
import {Scrollbars} from "react-custom-scrollbars";
import {HEADER_HEIGHT} from "../../../../../constants";
import BaseComponent from "../../../../../base/BaseComponent";
import {getMaxWidth} from "../../utils";

export default class StatisticsTable extends BaseComponent {
    static defaultProps = {
        defaultItemWidth: 100,
        tableHeight: 100,
        columns:[],
        handleTableChange:()=>{}
    };
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    itemHeight = 53;
    render() {
        let {columns,defaultItemWidth,tableHeight,dataSource,handleTableChange } = this.props;
        let scrollX = this.getScrollX(columns,defaultItemWidth);
        let scrollY = this.getScrollY(tableHeight,dataSource);
        let scrollYMax = scrollY.y + 53;
        return (
            <div className={'st_table'}>
                {/*<Scrollbars autoHeight autoHeightMax={scrollYMax}>*/}
                    <BaseTable
                        rowKey="id"
                        columns={columns}
                        dataSource={dataSource}
                        // x 当前表格最大宽度 y 最大高度
                        scroll={{ ...scrollX,...scrollY}}
                        onChange={(pagination, filters, sorter)=>{handleTableChange(pagination,filters, sorter)}}
                    />
                    <style>{`
                    .ant-table-fixed-header .ant-table-scroll .ant-table-header{
                        padding-bottom:9px !important;
                    }
                    .st_table .ant-table-placeholder{
                        border-top:initial;
                    }
                    `}</style>
                {/*</Scrollbars>*/}
            </div>
        )
    }
    thisPageMargin = 30;
    thisPagePadding = 64;
    // 如果当前表格宽度大于最大宽度，则中间需要滚动，否则不需要滚动
    getScrollX = (columns,defaultItemWidth) => {
        let scrollX = {};
        let maxWidth = getMaxWidth(this.thisPageMargin+this.thisPagePadding);
        let columnsWidth = this.getColumnsWidth(columns,defaultItemWidth) || 0;
        if(columnsWidth > maxWidth) {
            scrollX.x = columnsWidth
        }
        return scrollX
    };

    getScrollY = (tableHeight,dataSource) => {
        let scrollY = {};
        let maxHeight = tableHeight- this.itemHeight;
        // return {y:maxHeight}
        if(dataSource?.length) {
            let scrollH = dataSource.length * this.itemHeight;
            // if(scrollH > maxHeight) {
            // 切换滚动条状态会造成列表头重新渲染
                scrollY.y = maxHeight
            // }
        }
        return scrollY
    };

    getColumnsWidth = (columns,defaultItemWidth) => {
        let columnsWidth = 0;
        if(columns?.length) {
            columns.forEach(column=>{
                if(column?.width) {
                    columnsWidth+=column.width
                } else {
                    columnsWidth+=defaultItemWidth
                }
            })
        }
        return columnsWidth
    };
}